export class RuleId {
  private constructor(readonly value: string) {}

  static of(value: string | RuleId): RuleId {
    if (value instanceof RuleId) {
      return value;
    }
    return new RuleId(value);
  }
}
